import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Header.st.css';
import ModalHeading from './ModalHeading';
import { dataHooks } from '../../constants';
import Text from '../../../Text';
import { useBaseModalLayoutContext } from '../../BaseModalLayoutContext';
export var Header = function Header(_ref) {
  var dataHook = _ref.dataHook,
      className = _ref.className,
      titleAppearance = _ref.titleAppearance;

  var _useBaseModalLayoutCo = useBaseModalLayoutContext(),
      headerClassName = _useBaseModalLayoutCo.headerClassName,
      title = _useBaseModalLayoutCo.title,
      subtitle = _useBaseModalLayoutCo.subtitle;

  className = classNames(headerClassName, className);
  return (title || subtitle) && /*#__PURE__*/React.createElement("div", _extends({
    "data-hook": dataHook
  }, styles('root', {}, {
    className: className
  })), typeof title === 'string' ? /*#__PURE__*/React.createElement(ModalHeading, {
    className: styles.title,
    dataHook: dataHooks.headerTitle,
    headingAppearance: titleAppearance
  }, title) : title, subtitle && /*#__PURE__*/React.createElement(Text, {
    className: styles.subtitle,
    secondary: true,
    dataHook: dataHooks.headerSubtitle
  }, subtitle)) || null;
};
Header.displayName = 'BaseModalLayout.Header';
Header.propTypes = {
  /** additional css classes */
  className: PropTypes.string,

  /** data hook for testing */
  dataHook: PropTypes.string,

  /** The modal's title */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** The modal's title appearance */
  titleAppearance: ModalHeading.propTypes.headingAppearance,

  /** The modal's subtitle */
  subtitle: PropTypes.string
};
Header.defaultProps = {
  titleAppearance: 'custom'
};